import { fasEnvelope, farFile, fasTv, fasChartLine, fasCommentSms, fasPhone, fabWhatsapp } from '@quasar/extras/fontawesome-v6'
import { faMemo, faNotebook } from '@fortawesome/pro-regular-svg-icons'
import { getInlineIcon } from '@/common/helpers/icon'

export const enum CaseChannelEnum {
  MAIL = 'MAIL',
  FILE = 'FILE',
  FORM = 'FORM',
  SATISFACTION = 'SATISFACTION',
  SMS = 'SMS',
  CALL = 'CALL',
  API = 'API',
  WHATSAPP = 'WHATSAPP',
}

export const enum InteractionChannelEnum {
  MAIL = 'MAIL',
  SATISFACTION = 'SATISFACTION',
  SMS = 'SMS',
  CALL = 'CALL',
  API = 'API',
  WHATSAPP = 'WHATSAPP',
  EXTERNAL = 'EXTERNAL',
}

export const getCaseChannelIconName = (channelCode: CaseChannelEnum) => {
  switch (channelCode) {
    case CaseChannelEnum.MAIL:
      return fasEnvelope
    case CaseChannelEnum.FILE:
      return farFile
    case CaseChannelEnum.FORM:
      return fasTv
    case CaseChannelEnum.SATISFACTION:
      return fasChartLine
    case CaseChannelEnum.SMS:
      return fasCommentSms
    case CaseChannelEnum.CALL:
      return fasPhone
    case CaseChannelEnum.WHATSAPP:
      return fabWhatsapp
    case CaseChannelEnum.API:
      return getInlineIcon(faMemo)
    default:
      return undefined
  }
}

export const getInteractionChannelIconName = (channelCode: InteractionChannelEnum) => {
  switch (channelCode) {
    case InteractionChannelEnum.MAIL:
      return fasEnvelope
    case InteractionChannelEnum.SATISFACTION:
      return fasChartLine
    case InteractionChannelEnum.SMS:
      return fasCommentSms
    case InteractionChannelEnum.CALL:
      return fasPhone
    case InteractionChannelEnum.WHATSAPP:
      return fabWhatsapp
    case InteractionChannelEnum.EXTERNAL:
      return getInlineIcon(faNotebook)
    case InteractionChannelEnum.API:
      return getInlineIcon(faMemo)
    default:
      return undefined
  }
}

export const Channels = {
  SMS: 8,
  WHATSAPP: 19,
} as const

export type ChannelsIds = (typeof Channels)[keyof typeof Channels]

export type ChannelsAvailability = Partial<Record<ChannelsIds, boolean>>

export type ChannelDTOV1 = {
  code: CaseChannelEnum
  active: boolean
  displayOrder: number
}
